const isFilterSelected = (selected: any = []) => selected.some(({ items }) => items.some(i => i.checked));

export default isFilterSelected;
